"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksConnectSyncedCount = exports.QuickbooksConnectSettingsUpdate = exports.QuickbooksConnectSettings = exports.SyncStatus = exports.AccountingIntegrationType = exports.SyncStatuses = exports.AccountingIntegrationTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.AccountingIntegrationTypes = ['QUICKBOOKS_ONLINE', 'QUICKBOOKS_DESKTOP'];
exports.SyncStatuses = ['AUTO', 'MANUAL', 'OFF'];
exports.AccountingIntegrationType = typebox_1.Type.Union(exports.AccountingIntegrationTypes.map((type) => typebox_1.Type.Literal(type)));
exports.SyncStatus = typebox_1.Type.Union(exports.SyncStatuses.map((type) => typebox_1.Type.Literal(type)));
exports.QuickbooksConnectSettings = typebox_1.Type.Object({
    haulerID: typebox_1.Type.String(),
    accountingIntegrationType: exports.AccountingIntegrationType,
    bankAccount: typebox_1.Type.Optional(typebox_1.Type.String()),
    enableSync: typebox_1.Type.Boolean(),
    syncStatus: exports.SyncStatus,
    omitLineItems: typebox_1.Type.Array(typebox_1.Type.String()),
    defaultReceivableLineItem: typebox_1.Type.Optional(typebox_1.Type.String()),
    cutoffDate: typebox_1.Type.String({ format: 'date' }),
    assumeReconciledAfter: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Integer())),
    customLineItemNames: typebox_1.Type.Array(typebox_1.Type.String(), {
        description: '"Custom" line item names automatically detected during invoice sync.',
    }),
    paymentMethodsMappedToUndepositedFunds: typebox_1.Type.Array(common_1.PaymentMethod),
});
exports.QuickbooksConnectSettingsUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.QuickbooksConnectSettings, ['haulerID', 'customLineItemNames']));
exports.QuickbooksConnectSyncedCount = typebox_1.Type.Object({
    vendors: typebox_1.Type.Object({
        total: typebox_1.Type.Integer(),
        synced: typebox_1.Type.Integer(),
        errors: typebox_1.Type.Integer(),
        errorList: typebox_1.Type.Array(typebox_1.Type.Object({
            label: typebox_1.Type.String(),
            message: typebox_1.Type.String(),
        })),
    }),
    customers: typebox_1.Type.Object({
        total: typebox_1.Type.Integer(),
        synced: typebox_1.Type.Integer(),
        errors: typebox_1.Type.Integer(),
        errorList: typebox_1.Type.Array(typebox_1.Type.Object({
            label: typebox_1.Type.String(),
            message: typebox_1.Type.String(),
        })),
    }),
    invoices: typebox_1.Type.Object({
        total: typebox_1.Type.Integer(),
        synced: typebox_1.Type.Integer(),
        errors: typebox_1.Type.Integer(),
        errorList: typebox_1.Type.Array(typebox_1.Type.Object({
            label: typebox_1.Type.String(),
            message: typebox_1.Type.String(),
        })),
    }),
    payments: typebox_1.Type.Object({
        total: typebox_1.Type.Integer(),
        synced: typebox_1.Type.Integer(),
        errors: typebox_1.Type.Integer(),
        errorList: typebox_1.Type.Array(typebox_1.Type.Object({
            label: typebox_1.Type.String(),
            message: typebox_1.Type.String(),
        })),
    }),
    refunds: typebox_1.Type.Object({
        total: typebox_1.Type.Integer(),
        synced: typebox_1.Type.Integer(),
        errors: typebox_1.Type.Integer(),
        errorList: typebox_1.Type.Array(typebox_1.Type.Object({
            label: typebox_1.Type.String(),
            message: typebox_1.Type.String(),
        })),
    }),
});
//# sourceMappingURL=settings.js.map